import { trackingIntegrationListQuerySchema, type TrackingIntegration } from '@chukua/common';
import { useToast } from '../../../shared/hooks/use-toast';
import { useListQuery } from '../../../shared/hooks/use-list-query';
import { disableIntegration, enableIntegration, listIntegrations, uninstallIntegration } from '../integrations.api';
import { apiErrorReason } from '../policies/api-error-reason.policy';
import { usePagedList } from '../../../shared/hooks/use-paged-list';

/** The installed list plus its row actions. They have no form, so a failure toasts (CLAUDE.md → Web conventions → Feedback), with the API's reason (a failed connection test on enable). */
export function useInstalledIntegrations() {
  const list = useListQuery(trackingIntegrationListQuerySchema);
  const { state, isRefreshing, reload } = usePagedList(list.query, listIntegrations);
  const toast = useToast();

  async function rowAction(action: () => Promise<unknown>, success: string, failure: string): Promise<void> {
    try {
      await action();
      await reload();
      toast.success(success);
    } catch (err) {
      toast.error(apiErrorReason(err, failure));
    }
  }

  return {
    list,
    state,
    isRefreshing,
    reload,
    enable: (item: TrackingIntegration) => rowAction(() => enableIntegration(item.id), `${item.displayName} enabled`, `Couldn't enable ${item.displayName}`),
    disable: (item: TrackingIntegration) =>
      rowAction(() => disableIntegration(item.id), `${item.displayName} disabled`, `Couldn't disable ${item.displayName}`),
    uninstall: (item: TrackingIntegration) =>
      rowAction(() => uninstallIntegration(item.id), `${item.displayName} uninstalled`, `Couldn't uninstall ${item.displayName}`),
  };
}
